import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGemini = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("path", {
				id: "gemini-sparkle",
				d: "M11.04 19.32Q12 21.51 12 24q0-2.49.93-4.68.96-2.19 2.58-3.81t3.81-2.55Q21.51 12 24 12q-2.49 0-4.68-.93a12.3 12.3 0 0 1-3.81-2.58 12.3 12.3 0 0 1-2.58-3.81Q12 2.49 12 0q0 2.49-.96 4.68-.93 2.19-2.55 3.81a12.3 12.3 0 0 1-3.81 2.58Q2.49 12 0 12q2.49 0 4.68.96 2.19.93 3.81 2.55t2.55 3.81"
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "gemini-red",
				cx: 12,
				cy: 0,
				r: 11,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .4,
					stopColor: "#EA4335"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EA4335",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "gemini-yellow",
				cx: 0,
				cy: 12,
				r: 11,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .4,
					stopColor: "#FBBC04"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FBBC04",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "gemini-green",
				cx: 12,
				cy: 24,
				r: 11,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .4,
					stopColor: "#34A853"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#34A853",
					stopOpacity: 0
				})]
			})
		] }),
		/* @__PURE__ */ _jsx("use", {
			href: "#gemini-sparkle",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#gemini-sparkle",
			fill: "url(#gemini-red)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#gemini-sparkle",
			fill: "url(#gemini-yellow)"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#gemini-sparkle",
			fill: "url(#gemini-green)"
		})
	]
});
export default SvgGemini;
